import React, { useContext } from 'react';
import './onlyWhatsApp.css';
import { useState } from 'react';

import AiDrivenLogo from '../../assets/gradeIcons/aiDrivenEngine.png';
import OBDScanner from '../../assets/gradeIcons/OBDScanner.png';
import UnbiasedCustomer from '../../assets/gradeIcons/unbiasedCustomer.png';
import GppGoodIcon from '@mui/icons-material/GppGood';
import { Divider } from '@mui/material';
import { MyContext } from '../../context';

function OnlyWhatsApp() {
  const { pageData } = useContext(MyContext);

  const [isModalOpen, setIsmodalOpen] = useState(false);
  const toggleModal = () => {
    setIsmodalOpen((prevState) => !prevState);
    document.body.style.overflow = isModalOpen ? 'auto' : 'hidden';
  };
  const handleGetWarranty = () => {
    alert();
  };
  return (
    <section className="onlyApp-background">
      <div id="why-wisedrive" className="container">
        <div className="onlyWhatsApp">
          <div className="commonHeading">{pageData?.onlyWhatsApp?.header}</div>
        </div>
        <div className="onlyWhatsApp-cards">
          <div className="card">
            <img
              loading="lazy"
              src={pageData?.onlyWhatsApp?.gradeCardsData?.[0]?.src}
              alt=""
              style={{ color: '#25632d', width: '50px', height: '50px' }}
            />

            <div style={{ marginTop: '20px' }}>
              <h6 style={{ color: '#25632d' }}>
                {pageData?.onlyWhatsApp?.gradeCardsData?.[0]?.header}
              </h6>
              <Divider
                style={{
                  borderColor: '#25632d',
                  borderWidth: '2px',
                  marginBottom: '1.5rem',
                  marginTop: '1rem',
                }}
              />
              <p style={{ color: '#25632d' }}>
                {pageData?.onlyWhatsApp?.gradeCardsData?.[0]?.content}
              </p>
            </div>
          </div>
          <div className="card" style={{ backgroundColor: '#0c286a' }}>
            <img
              loading="lazy"
              alt=""
              src={pageData?.onlyWhatsApp?.gradeCardsData?.[1]?.src}
              style={{ color: 'white', width: '50px', height: '50px' }}
            />

            <div style={{ marginTop: '20px' }}>
              <h6 style={{ color: 'white' }}>
                {pageData?.onlyWhatsApp?.gradeCardsData?.[1]?.header}
              </h6>
              <Divider
                style={{
                  borderColor: 'white',
                  borderWidth: '2px',
                  marginBottom: '1.5rem',
                  marginTop: '1rem',
                }}
              />
              <p style={{ color: 'white' }}>
                {pageData?.onlyWhatsApp?.gradeCardsData?.[1]?.content}
              </p>
            </div>
          </div>
          <div className="card">
            <img
              loading="lazy"
              alt=""
              src={pageData?.onlyWhatsApp?.gradeCardsData?.[2]?.src}
              style={{ color: '#0c286a', width: '50px', height: '50px' }}
            />
            <div style={{ marginTop: '20px' }}>
              <h6>{pageData?.onlyWhatsApp?.gradeCardsData?.[2]?.header}</h6>
              <Divider
                style={{
                  borderColor: '#0c286a',
                  borderWidth: '2px',
                  marginTop: '1rem',
                  marginBottom: '1.5rem',
                }}
              />
              <p>{pageData?.onlyWhatsApp?.gradeCardsData?.[2]?.content}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OnlyWhatsApp;
